<ish-content-design-view-wrapper [pageletId]="pageletId()">
  <ng-container #cmsOutlet />
</ish-content-design-view-wrapper>
